export const LabelsEnum = {
  new: "new",
  sales: "sales",
  featured: "featured",
  jewellery: "jewellery",
  rings: "rings",
  bracelets: "bracelets",
  necklaces: "necklaces",
  earrings: "earrings",
  weekly: "weekly",
} as const;

export const CollectionLabels = {
  jewelleryUnder80: "collection-jewellery-under-80",
  pearlGiftsForHer: "collection-pearl-gifts-for-her",
  sterlingSilverUnder100: "collection-sterling-silver-under-100",
  vintageInspiredJewellery: "collection-vintage-inspired-jewellery",
  weddingGuestJewellery: "collection-wedding-guest-jewellery",
} as const;
